const itkConfig = {
  itkModulesPath: 'itk',
};
export default itkConfig;
